module.exports = __webpack_public_path__ + "static/media/equipment_05.adfc5152.jpg";